import React, { memo } from "react";
import {
  Box,
  Drawer,
  List,
  useTheme,
  useMediaQuery,
  Divider,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import MenuSection from "./MenuSection";
import { Link } from "react-router-dom";

const SideMenu = memo(
  ({
    menu,
    pathname,
    mobileMenuOpen,
    closeMobileMenu,
    navigationSections,
    navigationLoading,
  }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const normalizedUri = pathname.startsWith("/")
      ? pathname.substring(1)
      : pathname;

    const menuContent = (
      <List className={`side-menu-list ${isMobile ? "mobile" : ""}`}>
        {isMobile && navigationSections && !navigationLoading && (
          <>
            {navigationSections.map((section) => {
              const isSelected =
                pathname === section.path ||
                pathname.startsWith(`${section.path}/`);

              return (
                <ListItem key={section.key} disablePadding className="nav-item">
                  <ListItemButton
                    component={Link}
                    to={section.path}
                    onClick={closeMobileMenu}
                    className={`nav-button ${isSelected ? "selected" : ""}`}
                  >
                    <ListItemText
                      primary={section.title}
                      primaryTypographyProps={{
                        className: `nav-text ${isSelected ? "selected" : ""}`,
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              );
            })}
            <Divider className="menu-divider" />
          </>
        )}

        {menu?.menu?.map((section, index) => (
          <MenuSection
            key={`${section.title || "no-title"}-${index}`}
            section={section}
            uri={normalizedUri}
            pathname={pathname}
            closeMobileMenu={closeMobileMenu}
          />
        ))}

        <Box className="flex-spacer" />
      </List>
    );

    const drawerWidth = isMobile ? 280 : 320;

    if (isMobile) {
      return (
        <Drawer
          variant="temporary"
          open={mobileMenuOpen}
          onClose={closeMobileMenu}
          ModalProps={{ keepMounted: true }}
          className="side-drawer mobile"
          sx={{
            width: drawerWidth,
            "& .MuiDrawer-paper": { width: drawerWidth },
          }}
        >
          {menuContent}
        </Drawer>
      );
    }

    return (
      <Drawer
        variant="permanent"
        className="side-drawer desktop"
        sx={{
          width: drawerWidth,
          "& .MuiDrawer-paper": { width: drawerWidth },
        }}
      >
        {menuContent}
      </Drawer>
    );
  },
);

SideMenu.displayName = "SideMenu";

export default SideMenu;